import { Injectable } from '@angular/core';
import { GetAllResponse } from '../model/restful-api.model';
import { environment } from 'src/environments/environment';
import { API_URL } from '../enums/api-enums';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { Observable } from 'rxjs';
import { SupportEmail } from '../model/support-email.model';
import { ActionTrainingDocumentactive } from '../model/action-training-document.model';
import { ApplicationTrainingDocument } from '../model/application-training-document.model';

@Injectable({
  providedIn: 'root'
})

export class ActionTrainingDocumentService {
  constructor(
    private utilities: UtilitiesService) { }

  changeActiveApplication(id, active, type): Observable<GetAllResponse<ActionTrainingDocumentactive>> {
    const url = environment.portalURL + type + `/${id}/active/${active}`;
    return this.utilities.req.httpPut<GetAllResponse<ActionTrainingDocumentactive>>(url);
  }

  deleteApplication(id, type): Observable<GetAllResponse<ApplicationTrainingDocument>> {
    const url = environment.portalURL + type + `/${id}`;
    return this.utilities.req.httpDelete<GetAllResponse<ApplicationTrainingDocument>>(url);
  }

}
